import styled from 'styled-components';

export const ButtonContainer = styled.div`
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 20px;
  z-index: 1000;
`;

export const NavButton = styled.button`
  width: 50px;
  height: 50px;
  border-radius: 25px;
  background-color: rgba(52, 73, 94, 0.9);
  color: #fff;
  font-size: 24px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: rgba(44, 62, 80, 0.9);
  }

  &:active {
    background-color: rgba(36, 52, 70, 0.9);
  }
`;
